import api from './api';

const BASE_URL = '/users';

class UserService {
  constructor() {
    this.httpClient = api;
  }

  async currentUser() {
    try {
      const user = await (await this.httpClient.get(`${BASE_URL}/me`)).data;
      return user;
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }

  async confirmUser({ token, password }) {
    try {
      await this.httpClient.post(`${BASE_URL}/confirm`, { token, password });
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }

  async updateFirstAccess({ user }) {
    try {
      await this.httpClient.put(`${BASE_URL}/${user.id}`, {
        ...user,
        firstAccess: false,
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }

  async users() {
    try {
      const users = (await this.httpClient.get(BASE_URL)).data;
      return users;
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      throw new Error(errorMessage);
    }
  }
}

export default new UserService();
